export default "__VITE_ASSET__BEW2Aovs__"